import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="B" transform="translate(37.000000, 31.000000)">
        <path
          d="M 4.396 21.487 L 4.396 15.213 A 19.947 19.947 0 0 1 4.791 11.06 C 5.699 6.815 8.16 4.455 12.07 4.121 A 11.674 11.674 0 0 1 13.063 4.08 C 16.863 4.08 19.695 6.344 20.585 9.897 A 10.081 10.081 0 0 1 20.876 12.039 L 25.246 12.039 A 14.661 14.661 0 0 0 24.19 6.643 C 22.724 3.14 19.79 0.885 15.746 0.213 A 16.226 16.226 0 0 0 13.087 0.003 A 13.846 13.846 0 0 0 6.848 1.348 C 2.446 3.545 0.002 8.355 0.002 15.213 L 0.002 21.487 A 22.194 22.194 0 0 0 0.777 27.567 C 2.446 33.42 6.751 36.697 13.087 36.697 C 19.996 36.697 24.816 32.451 25.197 26.093 A 13.724 13.724 0 0 0 25.221 25.271 L 20.876 25.271 A 8.395 8.395 0 0 1 20.062 28.789 C 19.143 30.648 17.486 31.906 15.272 32.394 A 10.149 10.149 0 0 1 13.087 32.62 C 7.979 32.62 5.056 29.555 4.496 23.686 A 23.144 23.144 0 0 1 4.396 21.487 Z"
          fill="currentColor"
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
